module.exports = __webpack_public_path__ + "static/img/bg-pt.4b7dd106.png";